import { render, staticRenderFns } from "./RawMaterialSupplier.vue?vue&type=template&id=581f4466&scoped=true"
import script from "./RawMaterialSupplier.vue?vue&type=script&lang=js"
export * from "./RawMaterialSupplier.vue?vue&type=script&lang=js"
import style0 from "./RawMaterialSupplier.vue?vue&type=style&index=0&id=581f4466&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581f4466",
  null
  
)

export default component.exports